import { render, staticRenderFns } from "./search-dropdown.vue?vue&type=template&id=53f40140&scoped=true"
import script from "./search-dropdown.vue?vue&type=script&lang=js"
export * from "./search-dropdown.vue?vue&type=script&lang=js"
import style0 from "./search-dropdown.vue?vue&type=style&index=0&id=53f40140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f40140",
  null
  
)

export default component.exports